import React from "react";
import { CalendarOutlined } from "@ant-design/icons";

export const listMenu = [
  {
    isSubMenu: false,
    icon: <CalendarOutlined />,
    key: "sku",
    text: "menu.sku",
    path: "/panel/sku",
  },
  {
    isSubMenu: false,
    icon: <CalendarOutlined />,
    key: "product",
    text: "menu.product",
    path: "/panel/product",
  },
  {
    isSubMenu: false,
    icon: <CalendarOutlined />,
    key: "invetory-history",
    text: "menu.history",
    path: "/panel/invetory-history",
  },
  {
    isSubMenu: false,
    icon: <CalendarOutlined />,
    key: "store-requisition",
    text: "menu.storeRequest",
    path: "/panel/store-requisition",
  },
  {
    isSubMenu: false,
    icon: <CalendarOutlined />,
    key: "transfer",
    text: "menu.transfer",
    path: "/panel/transfer",
  },
  {
    isSubMenu: false,
    icon: <CalendarOutlined />,
    key: "warehouseAccess",
    text: "menu.warehouseAccess",
    path: "/panel/warehouseAccess",
  },
  {
    isSubMenu: false,
    icon: <CalendarOutlined />,
    key: "warehouse",
    text: "menu.warehouse",
    path: "/panel/warehouse",
  }
];
